export enum REJECT_HINT_TYPES {
  CERTIFICATE = 'cert',
  STEP = 'step',
  AUDIT_REJECT = 'auditReject',
  AUDIT_PAUSE = 'auditPause',
  OPTIONAL_PHASE = 'optional_phase',
  OPTIONAL_STEP = 'optional_step',
}
